import { BusinessListResponse, BusinessSector, BusinessType } from '@/types/listHelper/ListHelper.types';
import http from './http';

export const businessApi = {
  getSectors: (params?: { page?: number; limit?: number }) => http.get<BusinessListResponse<BusinessSector>>('/business/sectors', { params }).then((r) => r.data),

  getTypes: (params?: { page?: number; limit?: number; sectorId?: string }) => http.get<BusinessListResponse<BusinessType>>('/business/types', { params }).then((r) => r.data),
};
